function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import commonProps from './props';
import Header from './header';
import Combobox from './combobox';
export default {
  name: buildComponentName('TimepickerPanel'),
  provide: function provide() {
    return {
      timePanelRoot: this
    };
  },
  props: _objectSpread({}, commonProps, {
    visible: {
      type: Boolean,
      default: false
    },
    triggerRef: {
      type: Object,
      default: null
    }
  }),
  methods: {
    onChange: function onChange(value) {
      this.$emit('change', value);
    },
    onSelect: function onSelect(type, value) {
      this.$emit('select', type, value);
    },
    onClear: function onClear() {
      this.$emit('clear');
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        prefixCls = this.prefixCls;
    return h("div", {
      "class": "".concat(prefixCls, "-inner")
    }, [h(Header), h(Combobox), $slots.addon]);
  }
};